<template>
  <v-main class="grey lighten-4">
    <v-container>
      <v-card class="rounded-xl elevation-4" max-width="1200">
        <!-- Cabeçalho -->
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-plus-circle</v-icon>
          Cadastrar Serviço
        </v-card-title>

        <v-divider></v-divider>

        <!-- Formulário -->
        <v-form
          v-model="valid"
          ref="form"
          class="pa-6"
          @submit.prevent="cadastrarServico"
        >
          <!-- Seleção de Serviço -->
          <v-autocomplete
            v-model="servico"
            label="Serviço *"
            :items="listaServicos"
            item-text="nomeEspecialidade"
            item-value="idExameEspecialidade"
            :rules="[v => !!v || 'Serviço obrigatório']"
            outlined
            dense
            return-object
            prepend-icon="mdi-medical-bag"
            @input="buscar(servico)"
          ></v-autocomplete>

          <!-- Local da Recepcionista -->
          <v-autocomplete
            v-model="idLocal"
            label="Local da Recepcionista *"
            :items="listaLocais"
            item-text="nomeLocal"
            item-value="idLocal"
            :rules="[v => !!v || 'Local obrigatório']"
            outlined
            dense
            prepend-icon="mdi-map-marker"
          ></v-autocomplete>

          <!-- Seção Condicional: Configurações Médicas -->
          <template v-if="servico && servico.atendimentoMedico == 1">
            <v-subheader class="pl-0 mt-2 text-subtitle-1 primary--text">
              <v-icon left color="primary">mdi-stethoscope</v-icon>
              Configurações Médicas
            </v-subheader>

            <!-- Locais de Atendimento -->
            <v-autocomplete
              v-model="idLocaisMedico"
              label="Locais de Atendimento *"
              :items="listaLocais"
              item-text="nomeLocal"
              item-value="idLocal"
              :rules="[v => v && v.length > 0 || 'Selecione pelo menos um local']"
              outlined
              dense
              multiple
              chips
              small-chips
              prepend-icon="mdi-hospital-marker"
            ></v-autocomplete>

            <!-- Médicos -->
            <v-autocomplete
              v-model="idMedicos"
              label="Médicos *"
              :items="listaMedicos"
              item-value="idMedico"
              :item-text="item => `${item.nome} - ${item.login}`"
              :rules="[idMedicos.length > 0 || idTecnicos.length > 0 || 'Selecione pelo menos um prestador']"
              outlined
              dense
              multiple
              chips
              small-chips
              prepend-icon="mdi-doctor"
            ></v-autocomplete>

            <!-- Técnicos -->
            <v-autocomplete
              v-model="idTecnicos"
              label="Técnicos *"
              :items="listaTecnicos"
              item-value="idMedico"
              :item-text="item => `${item.nome} - ${item.login}`"
              :rules="[idMedicos.length > 0 || idTecnicos.length > 0 || 'Selecione pelo menos um prestador']"
              outlined
              dense
              multiple
              chips
              small-chips
              prepend-icon="mdi-account-cog"
            ></v-autocomplete>
          </template>

          <!-- Dias da Semana -->
          <v-autocomplete
            v-model="diasDaSemana"
            label="Dias da Semana *"
            :items="listaDiasDaSemana"
            item-text="dia"
            item-value="diaSemana"
            :rules="[v => v && v.length > 0 || 'Selecione pelo menos um dia']"
            outlined
            dense
            multiple
            chips
            small-chips
            prepend-icon="mdi-calendar"
          ></v-autocomplete>

          <!-- Opções -->
          <v-row class="mt-2">
            <v-col cols="12" sm="6">
              <v-checkbox
                v-model="exibirAtendente"
                :false-value="0"
                :true-value="1"
                label="Exibir serviço para a Atendente?"
                color="primary"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6">
              <v-checkbox
                v-model="peso"
                :false-value="0"
                :true-value="1"
                label="Prioridade para a recepcionista?"
                color="primary"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="checkbox"
                :rules="[v => !!v || 'Você deve concordar para cadastrar!']"
                label="Você concorda com os termos?"
                color="primary"
                required
              ></v-checkbox>
            </v-col>
          </v-row>

          <!-- Mensagens de Feedback -->
          <v-alert
            v-model="erroEditar"
            type="error"
            dismissible
            class="mt-4"
          >
            Serviço já existente nesta unidade. É possível apenas editar este serviço.
          </v-alert>

          <v-alert
            v-model="sucessoEditar"
            type="success"
            dismissible
            class="mt-4"
          >
            Serviço cadastrado com sucesso!
          </v-alert>

          <!-- Ações -->
          <v-card-actions class="px-0 mt-4">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              large
              rounded
              type="submit"
              :disabled="!valid"
              :loading="carregando"
            >
              <v-icon left>mdi-content-save</v-icon>
              Cadastrar
            </v-btn>
            <v-btn
              color="grey darken-1"
              large
              rounded
              outlined
              to="/servicosUnidade"
            >
              <v-icon left>mdi-arrow-left</v-icon>
              Voltar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'CadastrarServicoUnidade',
  data () {
    return {
      // Estados do formulário
      valid: false,
      carregando: false,
      erroEditar: false,
      sucessoEditar: false,
      checkbox: false,

      // Dados do formulário
      servico: null,
      idLocal: null,
      idLocaisMedico: [],
      idMedicos: [],
      idTecnicos: [],
      diasDaSemana: [],
      exibirAtendente: 0,
      peso: 0,

      // Listas de seleção
      listaServicos: [],
      listaLocais: [],
      listaMedicos: [],
      listaTecnicos: [],
      listaDiasDaSemana: [
        { dia: 'Segunda-feira', diaSemana: 1 },
        { dia: 'Terça-feira', diaSemana: 2 },
        { dia: 'Quarta-feira', diaSemana: 3 },
        { dia: 'Quinta-feira', diaSemana: 4 },
        { dia: 'Sexta-feira', diaSemana: 5 },
        { dia: 'Sábado', diaSemana: 6 },
        { dia: 'Domingo', diaSemana: 0 }
      ]
    }
  },
  mounted () {
    this.carregarDadosIniciais()
  },
  methods: {
    async carregarDadosIniciais () {
      try {
        await Promise.all([
          this.retornarLocais(),
          this.retornarExameEspecialidade(),
          this.retornarTodosMedicos(),
          this.retornarPossiveisTecnicos()
        ])
      } catch (error) {
        console.error('Erro ao carregar dados iniciais:', error)
      }
    },

    buscar (servico) {
      console.log('Serviço selecionado:', servico)
    },

    async retornarLocais () {
      try {
        const response = await administradorUnidadeService.administradorUnidade.retornarLocais()
        this.listaLocais = response.data
      } catch (error) {
        console.error('Erro ao carregar locais:', error)
        throw error
      }
    },

    async retornarTodosMedicos () {
      try {
        const response = await administradorUnidadeService.administradorUnidade.retornarTodosMedicos()
        this.listaMedicos = response.data
      } catch (error) {
        console.error('Erro ao carregar médicos:', error)
        throw error
      }
    },

    async retornarPossiveisTecnicos () {
      try {
        const response = await administradorUnidadeService.administradorUnidade.retornarPossiveisTecnicos()
        this.listaTecnicos = response.data
      } catch (error) {
        console.error('Erro ao carregar técnicos:', error)
        throw error
      }
    },

    async retornarExameEspecialidade () {
      try {
        const response = await administradorUnidadeService.administradorUnidade.retornarExameEspecialidade()
        this.listaServicos = response.data
      } catch (error) {
        console.error('Erro ao carregar serviços:', error)
        throw error
      }
    },

    async cadastrarServico () {
      if (!this.$refs.form.validate()) return

      this.carregando = true
      this.erroEditar = false
      this.sucessoEditar = false

      try {
        const dados = {
          idLocal: this.idLocal,
          idExameEspecialidade: this.servico.idExameEspecialidade,
          diasDaSemana: this.diasDaSemana,
          exibirAtendente: this.exibirAtendente,
          idLocaisMedico: this.servico.atendimentoMedico == 1 ? this.idLocaisMedico : [],
          peso: this.peso,
          idMedicos: this.servico.atendimentoMedico == 1 ? this.idMedicos : [],
          idTecnicos: this.servico.atendimentoMedico == 1 ? this.idTecnicos : []
        }

        const response = await administradorUnidadeService.administradorUnidade.cadastrarServico(dados)

        if (response.data === 'erro') {
          this.erroEditar = true
          this.servico = null
          this.clear()
        } else if (response.data === true) {
          this.sucessoEditar = true
          this.servico = null
          this.clear()
        }
      } catch (error) {
        console.error('Erro ao cadastrar serviço:', error)
        this.erroEditar = true
      } finally {
        this.carregando = false
      }
    },

    clear () {
      this.$refs.form.reset()
      this.peso = 0
      this.exibirAtendente = 0
    }
  }
}
</script>

<style scoped>
.v-card {
  border-radius: 12px;
  overflow: hidden;
}

.v-btn {
  text-transform: none;
  letter-spacing: normal;
  min-width: 120px;
}

.v-subheader {
  font-size: 1rem;
  height: 48px;
}

@media (max-width: 600px) {
  .v-card__title {
    font-size: 1.25rem;
    padding: 16px;
  }

  .v-btn {
    width: 100%;
    margin-bottom: 8px;
  }

  .v-card__actions {
    flex-direction: column;
  }
}
</style>
